import { Tile as TileLayer } from 'ol/layer';
import ImageTile from 'ol/source/ImageTile';
import { GetBearerHeader } from '../../services/api';
import { LoaderOptions } from 'ol/source/DataTile';

export const createAzureLayer = (): TileLayer => {
  const apiBaseUrl = (window as any)?._env_?.REACT_APP_API_BASE_URL
    ?? process.env.REACT_APP_API_BASE_URL
    ?? '';

  return new TileLayer({
    source: new ImageTile({
      crossOrigin: 'anonymous',
      maxZoom: 19,
      wrapX: false,
      loader: (z, x, y, loaderOptions: LoaderOptions) => {
        return fetch(
          `${apiBaseUrl}/api/map/azureTile?zoom=${z}&x=${x}&y=${y}`,
          {
            headers: {
              Authorization: GetBearerHeader().authorization
            },
            signal: loaderOptions?.signal
          }
        )
          .then(response => {
            if (!response.ok) {
              throw new Error(`Tile request failed: ${response.status}`);
            }
            return response.blob();
          })
          .then(blob => {
            return new Promise<HTMLImageElement>((resolve, reject) => {
              const img = new Image();
              const objectUrl = URL.createObjectURL(blob);
              img.onload = () => {
                URL.revokeObjectURL(objectUrl); // free memory after load
                resolve(img);
              };
              img.onerror = (e) => {
                URL.revokeObjectURL(objectUrl); // free memory on error
                reject(e);
              };
              img.src = objectUrl;
            });
          });
      }
    })
  });
};